import { AdvisorBubble, Column } from '@/components'
import { useSnackbar } from '@/providers'
import { useCreatePayment } from '@/services'
import { useTranslation } from 'react-i18next'
import { FormCheckBox, FormInputField } from '../../../../FormItem'
import { StepLayout } from '../components'
import { useChecklistStepper } from '../hooks/useChecklistStepper'
import { paymentMethodValidationSchema } from '../validationSchema'
import { PaymentMethodFormValues, StepperFormValues } from '../utils/types'

const PaymentMethodForm = () => {
  const { t } = useTranslation()

  return (
    <Column gap="16px">
      <Column>
        <FormInputField
          name="name"
          label={t('riskChecklist.businessInformationFlow.paymentMethod.name')}
        />
        <Column gap="8px">
          <FormInputField
            name="iban"
            label={t(
              'riskChecklist.businessInformationFlow.paymentMethod.iban',
            )}
          />
          <FormCheckBox
            name="sepa"
            label={t(
              'riskChecklist.businessInformationFlow.paymentMethod.sepa',
            )}
          />
        </Column>
      </Column>
      <AdvisorBubble
        text={t(
          'riskChecklist.businessInformationFlow.paymentMethod.advisorBubbleText',
        )}
      />
    </Column>
  )
}

const makeInitialValues = (formValues: StepperFormValues) => {
  if (formValues.name && formValues.iban && formValues.sepa) {
    return formValues
  }

  return {
    name: '',
    iban: '',
    sepa: false,
  }
}

interface PaymentMethodProps {
  companyId: string
}

export const PaymentMethod = ({ companyId }: PaymentMethodProps) => {
  const { t } = useTranslation()
  const snackbar = useSnackbar()
  const createPaymentMutation = useCreatePayment()
  const { goToNext, formValues } = useChecklistStepper()

  const handleSubmit = async (values: PaymentMethodFormValues) => {
    try {
      await createPaymentMutation.mutateAsync({
        name: values.name,
        iban: values.iban,
        bic: '',
        priority: 1,
        companyId,
      })
      goToNext(values)
    } catch (_e) {
      snackbar.error(t('snackbars.error.generalMsg'))
    }
  }

  return (
    <StepLayout
      title={t('riskChecklist.businessInformationFlow.paymentMethod.title')}
      subtitle={t(
        'riskChecklist.businessInformationFlow.paymentMethod.subtitle',
      )}
      onNext={handleSubmit}
      isLoading={createPaymentMutation.isLoading}
      initialValues={makeInitialValues(formValues)}
      validationSchema={() =>
        paymentMethodValidationSchema(
          t('validations', {
            returnObjects: true,
          }),
        )
      }
      onSkip={() => goToNext({})}
    >
      <PaymentMethodForm />
    </StepLayout>
  )
}
